import { render, staticRenderFns } from "./CodeBarreDbco.vue?vue&type=template&id=98c5d398"
import script from "./CodeBarreDbco.vue?vue&type=script&lang=js"
export * from "./CodeBarreDbco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports